import { ToolKey } from '../declarations/tools/tools';

export const TOOL_CLICK_METRIKA = 'TOOL_CLICK_METRIKA';
export type TOOL_CLICK_METRIKA = typeof TOOL_CLICK_METRIKA;

export interface ToolClickMetrikaAction {
    type: TOOL_CLICK_METRIKA;
    toolKey: ToolKey;
}

export function toolClickMetrika(toolKey: ToolKey): ToolClickMetrikaAction {
    return {
        type: TOOL_CLICK_METRIKA,
        toolKey
    };
}

export type ToolsAction = ToolClickMetrikaAction;
